import classNames from "classnames";
import { ImageAttachmentData } from "~/models/card";
import { CardItemLabel } from "~/widgets/card/components/CardItem";
import { LabelTag } from "~/common/charity/LabelTag";
import { AttachmentImageFull } from "./AttachmentImageFull";

/**
 * AttachmentImage
 *
 * This component is used to display an image with a label on top of it.
 * The label is meant to be used to display the category of a card
 *
 * @param {number} imageId The ID of the image to display.
 * @param {string} imagePosition (optional) The position of the image within its container.
 * @param {React.CSSProperties} style (optional) Additional styles to apply to the image.
 * @param {CardItemLabel} label The label to display on top of the image.
 * @param {string} className (optional) Additional class names to apply to the image.
 * @returns {*} React JSX
 */
export function AttachmentImageLabel({
  image,
  imagePosition,
  label,
  style,
  className,
}: {
  image?: ImageAttachmentData;
  imagePosition?: string;
  label: CardItemLabel;
  style?: React.CSSProperties;
  className?: string;
}) {
  return (
    <div
      className={classNames("tw:relative tw:!h-full tw:!w-full", className)}
      style={style}
    >
      <div className="tw:absolute tw:top-4 tw:right-4 tw:p-2">
        <LabelTag
          text={label.text}
          color={label.color}
          backgroundColor={label.backgroundColor}
        />
      </div>
      <AttachmentImageFull
        image={image}
        imagePosition={imagePosition}
        style={style}
        className={className}
      />
    </div>
  );
}
